import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ArrowIcon: FC<Props> = (props) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="arrow icon">
      {/* <title>arrow icon</title> */}
      <path
        d="M17.0667 10.2286C17.0667 10.545 16.8315 10.8065 16.5265 10.8479L16.4417 10.8536L5.45498 10.8531L9.42414 14.806C9.66874 15.0496 9.6696 15.4453 9.42604 15.6899C9.20463 15.9123 8.85746 15.9332 8.61239 15.7522L8.54216 15.6918L3.5005 10.6718C3.46825 10.6397 3.44025 10.6049 3.41648 10.5683C3.40977 10.5572 3.40293 10.5459 3.39645 10.5344C3.3905 10.5245 3.38511 10.5142 3.38003 10.5039C3.37298 10.4888 3.36608 10.4732 3.35982 10.4573C3.35474 10.445 3.35049 10.4331 3.34662 10.4211C3.34201 10.4062 3.33754 10.3903 3.33369 10.3741C3.33083 10.3629 3.32856 10.352 3.32659 10.3411C3.32381 10.3249 3.32144 10.3082 3.31975 10.2912C3.3183 10.2783 3.31742 10.2655 3.31693 10.2527C3.31681 10.2449 3.31665 10.2367 3.31665 10.2286L3.31697 10.2044C3.31744 10.1921 3.31828 10.1798 3.31948 10.1676L3.31665 10.2286C3.31665 10.1891 3.3203 10.1505 3.32729 10.1131C3.32891 10.1042 3.33084 10.095 3.33298 10.0859C3.33742 10.0671 3.34255 10.049 3.34846 10.0312C3.35136 10.0224 3.35474 10.0129 3.35835 10.0036C3.36565 9.98477 3.37359 9.96684 3.38232 9.94938C3.38638 9.94117 3.39092 9.93257 3.39568 9.92406C3.40349 9.91018 3.41154 9.89699 3.42005 9.88413C3.42605 9.87503 3.4327 9.86556 3.43964 9.85623L3.44505 9.84903C3.46188 9.82703 3.48015 9.80618 3.49971 9.78663L3.50046 9.78605L8.54213 4.76521C8.78671 4.52164 9.18244 4.52246 9.42601 4.76704C9.64744 4.98939 9.66689 5.33665 9.48484 5.58095L9.42418 5.65092L5.45665 9.60307L16.4417 9.60357C16.7868 9.60357 17.0667 9.88339 17.0667 10.2286Z"
        fill={props.fill || "currentColor" || "#52565C"}
      />
    </svg>
  );
};

export default ArrowIcon;
